package com.bikompanion.ui.composables

import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.SpringSpec
import androidx.compose.animation.core.spring

/**
 * One spring shared by everything that moves because a docked panel opens, closes or resizes: the
 * panel's own slide, the controls that step aside for it, and its height change. Identical
 * parameters over (almost) the same distance make them travel as a single object; mixing a tween
 * for the controls with the panel's default spring made them start and stop at different moments,
 * which read as harsh rather than as one movement.
 *
 * Critically damped on purpose: a bounce on a panel that carries text and a glass blur looks jittery.
 */
internal fun <T> dockedPanelSpring(visibilityThreshold: T? = null): SpringSpec<T> = spring(
    dampingRatio = Spring.DampingRatioNoBouncy,
    stiffness = DockedPanelStiffness,
    visibilityThreshold = visibilityThreshold,
)

private const val DockedPanelStiffness = 300f
